import styles from "./style.module.css";
import { Link } from "react-router-dom";
import { useContext, useState } from "react";
import { HeaderTextContext } from "../../../contextAdmin/hederText";
import logo from "./Logo.svg"
import { userContext } from "../../../contextAdmin/Admin/User";
import authRequets from "../../api/authRequests";
// Creator : Team E - Ariel
export default function Header() {
    const { headerText, setHeaderText } = useContext(HeaderTextContext);
    const { user, setUser } = useContext(userContext);
    const [popOut, setPopOut] = useState(false);
    const handlePopUpLogOut = () => {
        setPopOut(prev => !prev);
    }
    const signOutForReal = () => {
        authRequets.signOutUser().then(() => {
            setUser("")
        })

    }
    return (
        <>
            <div className={styles["admin-header"]}>
                <div className={styles.container}>
                    <Link className={styles.links} to="/classrooms">
                        <img src={logo} alt="logo1" />
                        {/* <img className={styles.logoName} src={require("./logo2.png")} alt="logo2" /> */}
                    </Link>

                    <PageName page={headerText} />

                    <div className={styles.imgContainer}>
                        {user.permissions == "admin" ? <div className={styles.switchBTN}>
                            <Link className={styles["header-title"]} to={headerText == "admin" ? "/classrooms" : "/teachers"}>
                                Switch to {headerText == "admin" ? "teacher" : "admin"} view
                            </Link>
                        </div>
                            : null}
                        <img onClick={handlePopUpLogOut} className={styles["user-logo"]} alt="avatar" src={require("../../../assets/profile_placeholder.png")} />
                        {popOut && <div onClick={signOutForReal} className={styles["logOutPop"]}>Log Out</div>}
                    </div>
                </div>
            </div>
        </>
    );
}

function PageName({ page }) {

    if (page === "admin") return <div className={styles["header-title"]}>Admin-Portal</div>;

    else return (
        <div className={styles.middle}>
            <Link className={styles[page ? "header-title-gray" : "header-title"]} to="/classrooms">
                Classrooms
            </Link>

            {page ?
                <div className={styles["header-title"]}>
                    <span className={styles["header-title-gray"]}>/ </span>
                    {page}
                </div>
                : ""
            }
        </div>
    )
}


